import { Icon } from '@iconify/react';

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const ScrollToTopButton = () => {
  return (
    <button
      id='clip_scroll_to_top_button'
      onClick={scrollToTop}
      className='fixed bottom-20 right-3 transform z-50 bg-[#1c1c1c] hover:bg-[#5c5c5c] text-[#c6c6c6] border-2 border-[#5c5c5c] shadow-lg rounded-full p-3 transition-all duration-300 ease-in-out'
    >
      <Icon icon='material-symbols:arrow-upward' className='w-8 h-8' />
    </button>
  );
};

export default ScrollToTopButton;
